import AccommodationDetail, { getServerSideProps as gSSP } from '../../components/pages/AccommodationDetail';

export default AccommodationDetail;

export const getServerSideProps = gSSP;
